// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QyXu","importantInfo":"styles_importantInfo__2RO3u"};